import { render, staticRenderFns } from "./__index_batch_update_price.vue?vue&type=template&id=358b3c82&"
import script from "./__index_batch_update_price.vue?vue&type=script&lang=js&"
export * from "./__index_batch_update_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports